import React from 'react';
import { Bot, Info } from 'lucide-react';
import { toast } from 'sonner';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

const TradingAssistantButton = ({ onClick, isAuthenticated, isAdmin, onLoginRequired }) => {
  const handleClick = () => {
    if (!isAuthenticated) {
      if (onLoginRequired) {
        onLoginRequired();
      }
      toast.info('Please login to use Trading Assistant');
      return;
    }
    if (!isAdmin) {
      toast.error('Trading Assistant is only available for admin users');
      return;
    }
    toast.success('Opening Trading Assistant...');
    onClick();
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleClick}
            className="flex items-center gap-2 px-4 py-2 rounded-full 
                       bg-gradient-to-r from-emerald-500 to-teal-500
                       hover:from-emerald-600 hover:to-teal-600
                       text-white font-medium transition-all duration-200
                       shadow-md hover:shadow-lg transform hover:scale-105"
            data-testid="trading-assistant-button"
          >
            <Bot className="w-4 h-4" />
            <span>AI Trading Assistant</span>
            <Info className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs bg-gray-900 text-white p-3 rounded-lg shadow-lg border border-white/10">
          <div className="space-y-2">
            <p className="font-semibold text-sm">🤖 AI Trading Assistant</p>
            <p className="text-xs text-gray-300">
              Powered by Claude AI with NLP capabilities:
            </p>
            <ul className="text-xs text-gray-300 list-disc list-inside space-y-1">
              <li><span className="text-emerald-400">Signal Queries</span> - Win rate, P&L, performance</li>
              <li><span className="text-yellow-400">Guard Activity</span> - V2.0.3-V2.0.7 blocks</li>
              <li><span className="text-blue-400">Alpaca Trading</span> - Paper trade stocks & crypto</li>
              <li><span className="text-purple-400">Portfolio</span> - Positions & orders</li>
            </ul>
            {!isAuthenticated && (
              <p className="text-xs text-yellow-400">⚠️ Login required (Admin only)</p>
            )}
            {isAuthenticated && !isAdmin && (
              <p className="text-xs text-yellow-400">⚠️ Admin access required</p>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TradingAssistantButton;
